<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: RelationshipResearchStatus                            |
| Section: components/Person                                       |
| Purpose: Explain an unverified or unavailable kinship status.    |
+------------------------------------------------------------------+
-->
<template>
    <div class="RelationshipResearchStatus_wrapper wrapper" :class="{
        'RelationshipResearchStatus_wrapper--error': loadError
    }" :role="loadError ? 'alert' : undefined">
        <p v-if="loadError" class="RelationshipResearchStatus_label">
            {{ $t('personPage.relationshipResearch.errorLabel') }}
        </p>
        <h2>
            {{ $t(loadError
                ? 'personPage.relationshipResearch.errorTitle'
                : 'personPage.relationshipResearch.title') }}
        </h2>
        <p class="RelationshipResearchStatus_description">
            {{ $t(loadError
                ? 'personPage.relationshipResearch.errorDescription'
                : 'personPage.relationshipResearch.description') }}
        </p>
        <div v-if="!loadError && visibleBranches.length" class="RelationshipResearchStatus_branches"
            :aria-label="$t('personPage.relationshipResearch.labelsAria')">
            <span v-for="(branch, index) in visibleBranches" :key="branch.branch || index"
                class="RelationshipResearchStatus_branch" v-html="branch.description"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RelationshipResearchStatus',
    props: {
        branches: {
            type: Array,
            default: () => []
        },
        loadError: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        visibleBranches() {
            return this.branches.filter(branch =>
                branch && typeof branch.description === 'string' && branch.description.trim()
            );
        }
    }
};
</script>

<style scoped>
.RelationshipResearchStatus_wrapper {
    display: flex;
    max-width: 1280px;
    padding: 96px;
    border-radius: var(--border-radius-xl);
    background-color: var(--brand-bg-1);
    box-shadow: var(--shadow-card-sm);
    box-sizing: border-box;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.RelationshipResearchStatus_label {
    color: var(--brand-color-1);
    font-size: 14px;
    font-weight: 700;
    letter-spacing: .08em;
    line-height: 1.4;
    text-align: center;
    text-transform: uppercase;
}

h2 {
    max-width: 800px;
    text-align: center;
}

.RelationshipResearchStatus_description {
    max-width: 760px;
    color: var(--brand-text-dark);
    line-height: 1.6;
    text-align: center;
}

.RelationshipResearchStatus_branches {
    display: flex;
    margin-top: 8px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}

.RelationshipResearchStatus_branch {
    max-width: 100%;
    padding: 6px 10px;
    border-radius: var(--border-radius-sm);
    background-color: var(--brand-color-1);
    color: var(--brand-text-light);
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    overflow-wrap: anywhere;
}

.RelationshipResearchStatus_wrapper--error .RelationshipResearchStatus_label {
    color: var(--brand-text-dark);
    opacity: .65;
}

@media (max-width: 860px) {
    .RelationshipResearchStatus_wrapper {
        width: calc(100% - 40px);
        padding: 32px 24px;
    }
}
</style>
